import {h} from "preact";
import s from "../beneficiaryForm.module.css";
import {useAppContext} from "../../../../contexts";

const GenderField = (props) => {
    // Destructured props
    const {
        formValues,
        errors,
        handleChange
    } = props;

    // Accessibility feature
    const {highContrast} = useAppContext();

    return (
        <fieldset className={"w-full flex flex-col items-start gap-y-1 justify-start"}>
            <p className={`${s.inputLabel} ${highContrast ? "highLabelFourth" : ""}`}>
                Gênero:&nbsp;
                <span className={`${highContrast ? "highTitleThird" : "text-sabin-red-default"}`}>
                    *
                </span>
            </p>
            <div className={"flex flex-row justify-between gap-x-1 items-start w-full"}>
                <label
                    htmlFor={"female-input"}
                    className={s.genderInputLabel}
                >
                    <input
                        type={"radio"}
                        id={"female-input"}
                        name={"gender"}
                        className={s.genderInput}
                        value={"2"}
                        onInput={handleChange}
                        checked={formValues.gender === '2'}
                    />
                    Feminino
                </label>
                <label
                    htmlFor={"male-input"}
                    className={s.genderInputLabel}
                >
                    <input
                        type={"radio"}
                        id={"male-input"}
                        name={"gender"}
                        className={s.genderInput}
                        value={"1"}
                        onInput={handleChange}
                        checked={formValues.gender === '1'}
                    />
                    Masculino
                </label>
            </div>
            {!!errors.gender && (
                <p className={`${s.errorMessage} ${highContrast ? "highTitleThird" : ""}`}>
                    {errors.gender}
                </p>
            )}
        </fieldset>
    )
}

export default GenderField;
